/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';

import Colors from '@global/colors';

function SociollaErrorMessage({ error, visible }) {
  if (!visible || !error) {
    return null;
  }

  return <SociollaText style={styles.error}>{error}</SociollaText>;
}

const styles = StyleSheet.create({
  error: {
    color: Colors.red3,
    fontSize: 12,
    marginTop: 6,
  },
});

export default SociollaErrorMessage;
